import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { Input } from './Input';
export function CreateWorkspaceModal({ open, onClose, onSubmit }) {
    const [name, setName] = useState('');
    function handleClose() {
        setName('');
        onClose();
    }
    return (_jsx(Modal, { open: open, onClose: handleClose, title: "Create workspace", actions: _jsxs(_Fragment, { children: [_jsx(Button, { variant: "ghost", onClick: handleClose, children: "Cancel" }), _jsx(Button, { variant: "primary", disabled: !name.trim(), onClick: () => { onSubmit?.(name); handleClose(); }, children: "Create workspace" })] }), children: _jsx("div", { className: "mt-2", children: _jsx(Input, { label: "Clinic name", placeholder: "e.g. City Dermatology", value: name, onChange: (e) => setName(e.target.value), autoFocus: true }) }) }));
}
